import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
dayjs.extend(duration);

export const formatSeconds = (val) => {
	const format = (val > 3599 ? 'HH:' : '') + 'mm:ss';
	return dayjs.duration(val, 'seconds').format(format);
};
export const formatSecondsToIso = (val) => dayjs.duration(val, 'seconds').toISOString();
